var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 1.66667C5.40835 1.66667 1.66669 5.40834 1.66669 10C1.66669 14.5917 5.40835 18.3333 10 18.3333C14.5917 18.3333 18.3334 14.5917 18.3334 10C18.3334 5.40834 14.5917 1.66667 10 1.66667ZM12.8 11.9167C13.0417 12.1583 13.0417 12.5583 12.8 12.8C12.675 12.925 12.5167 12.9833 12.3584 12.9833C12.2 12.9833 12.0417 12.925 11.9167 12.8L10 10.8833L8.08335 12.8C7.95835 12.925 7.80002 12.9833 7.64169 12.9833C7.48335 12.9833 7.32502 12.925 7.20002 12.8C6.95835 12.5583 6.95835 12.1583 7.20002 11.9167L9.11669 10L7.20002 8.08334C6.95835 7.84167 6.95835 7.44167 7.20002 7.20001C7.44169 6.95834 7.84169 6.95834 8.08335 7.20001L10 9.11667L11.9167 7.20001C12.1584 6.95834 12.5584 6.95834 12.8 7.20001C13.0417 7.44167 13.0417 7.84167 12.8 8.08334L10.8834 10L12.8 11.9167Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseCircle);
export default __webpack_public_path__ + "static/media/close-circle.1360dd578692f41ddfa997a3ca946a27.svg";
export { ForwardRef as ReactComponent };